import { render } from "./scenicspot.vue?vue&type=template&id=125aac9e&scoped=true"
import script from "./scenicspot.vue?vue&type=script&lang=js"
export * from "./scenicspot.vue?vue&type=script&lang=js"

import "./scenicspot.vue?vue&type=style&index=0&id=125aac9e&scoped=true&lang=css"

import exportComponent from "D:\\CLionProjects\\vue_phone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125aac9e"]])

export default __exports__